




import { Component, Vue } from 'vue-property-decorator';
  @Component
export default class Base extends Vue {
  created () {
    document.title = this.$route.meta.title || 'Free-Time';
  }

  mounted () {
    let preloader = document.getElementById('p_prldr');
    if (preloader) {
      preloader.remove();
    }
  }
}
